import { useParams, useHistory } from "react-router-dom";
import { getCookie, setCookie } from "../utils/utmCookies";

const linkMap = {
    rx4j: {
        url: "/register?utm_source=tiktok&utm_medium=social&utm_campaign=neal_patel",
        referral: "rx4j"
    }
};

const ShortLinkRedirect = () => {
    const { code } = useParams();
    const history = useHistory();

    const cleanCode = code?.toLowerCase();
    const link = linkMap[cleanCode];

    let url = "/register";

    if (link) {
        url = link.url;
        const savedCampaign = getCookie(`hisably_utm_campaign`);
        if (!savedCampaign) { 
            const params = new URLSearchParams(url.split('?')[1]);
            if (params.get("utm_campaign") === "neal_patel") {
                const utm = {
                    utm_source: params.get("utm_source"),
                    utm_medium: params.get("utm_medium"),
                    utm_campaign: params.get("utm_campaign"),
                };
                Object.entries(utm).forEach(([key, value]) => {
                    if (value) {
                        setCookie(`hisably_${key}`, value, 30);
                    }
                });
                
            }
        }
    }

    history.replace(url);

  return null;
};

export default ShortLinkRedirect;